import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from 'react-apollo'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import client from './graphql'
import configureStore from './store'
import App from './pages/App'
import * as serviceWorker from './serviceWorker'
import { message } from 'antd'
import './index.css'
import 'antd/dist/antd.min.css'

require('dotenv').config()
message.config({
  top: 100
})
const { store, persistor } = configureStore()

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </ApolloProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()

if (module.hot) module.hot.accept()



// WEBPACK FOOTER //
// ./src/index.js